import { fontSizes } from 'appconstants';
import { cn } from 'lib/utils';

interface TextProps {
  text: string | React.ReactNode;
  className?: string;
  onClick?: () => void;
  size?: number;
}

const Text = ({ text, className, onClick, size }: TextProps) => {
  return (
    <p className={cn('text-black', onClick && 'cursor-pointer', className)} style={{ fontSize: size ?? fontSizes.h13 }} onClick={onClick}>
      {text}
    </p>
  );
};

export default Text;
